// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ThreadViewOpenEvent
 *
 * @deprecated This event is deprecated, Threads feature removed
 */
export var ThreadViewOpen = function (_a) {
    var entryPoint = _a.entryPoint, externalId = _a.externalId;
    return ({
        name: "Thread View Open",
        parameters: {
            cdf_entity: "Thread",
            cdf_action: "View",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreadInteractPublishMessageEvent
 *
 * @deprecated This event is deprecated, Threads feature removed
 */
export var ThreadInteractPublishMessage = function () { return ({
    name: "Thread Interact PublishMessage",
    parameters: {
        cdf_entity: "Thread",
        cdf_action: "Interact",
    }
}); };
/**
 * @see ThreadInteractAddReactionEvent
 *
 * @deprecated This event is deprecated, Threads feature removed
 */
export var ThreadInteractAddReaction = function (_a) {
    var emoji = _a.emoji, messageToken = _a.messageToken, ownerToken = _a.ownerToken;
    return ({
        name: "Thread Interact AddReaction",
        parameters: {
            cdf_entity: "Thread",
            cdf_action: "Interact",
            emoji: emoji !== undefined && emoji !== null ? emoji.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            owner_token: ownerToken !== undefined && ownerToken !== null ? ownerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreadInteractRemoveReactionEvent
 *
 * @deprecated This event is deprecated, Threads feature removed
 */
export var ThreadInteractRemoveReaction = function (_a) {
    var emoji = _a.emoji, messageToken = _a.messageToken, ownerToken = _a.ownerToken;
    return ({
        name: "Thread Interact RemoveReaction",
        parameters: {
            cdf_entity: "Thread",
            cdf_action: "Interact",
            emoji: emoji !== undefined && emoji !== null ? emoji.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            owner_token: ownerToken !== undefined && ownerToken !== null ? ownerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThreadInteractMessageActionEvent
 *
 * @deprecated This event is deprecated, Threads feature removed
 */
export var ThreadInteractMessageAction = function (_a) {
    var actionType = _a.actionType, messageToken = _a.messageToken, ownerToken = _a.ownerToken, paymentToken = _a.paymentToken;
    return ({
        name: "Thread Interact MessageAction",
        parameters: {
            cdf_entity: "Thread",
            cdf_action: "Interact",
            action_type: actionType !== undefined && actionType !== null ? actionType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            message_token: messageToken !== undefined && messageToken !== null ? messageToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            owner_token: ownerToken !== undefined && ownerToken !== null ? ownerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            payment_token: paymentToken !== undefined && paymentToken !== null ? paymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
